module.exports = __webpack_public_path__ + "img/4.9fb361c8.png";